import { formatEther } from "viem";
export function formatAmount(amount) {
  let decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  return (amount ? Number(formatEther(amount)) : 0).toFixed(decimals);
}